module.exports = __webpack_public_path__ + "img/assignment.7bd38299.svg";